import { ReactComponent as SupportIcon } from '../../assets/images/support.svg';
import './Support.scss';
import { Tooltip } from 'primereact/tooltip';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { ConfigService } from '../../service/ConfigService';
import { MessageContext } from '../../context/MessageContext';
import { useContext } from 'react';

const Support = () => {
    const { t } = useTranslation();
    const { showErrorMessage } = useContext(MessageContext);
    const [isLoading, setIsLoading] = useState(true);
    const [supportUrl, setSupportUrl] = useState(null);

    useEffect(() => {
        let isMounted = true;
        
        const fetchSupportUrl = async () => {
            try {
                setIsLoading(true);
                console.log('[Support] Pobieranie URL z konfiguracji przy renderowaniu...');
                
                const response = await ConfigService.getConfigByType('GUIDEJAR_URL');
                console.log('[Support] Otrzymano odpowiedź z API:', response);
                
                if (!isMounted) return;
                
                if (!response || !response.value) {
                    throw new Error('Brak URL w konfiguracji');
                }

                const url = response.value;
                console.log('[Support] URL pobrany pomyślnie:', url);
                setSupportUrl(url);
                
            } catch (err) {
                if (!isMounted) return;
                console.error('[Support] Błąd podczas pobierania URL:', err);
                showErrorMessage(t('support.error.fetchUrl', 'Nie udało się pobrać adresu wsparcia. Spróbuj ponownie później.'));
            } finally {
                if (isMounted) {
                    setIsLoading(false);
                }
            }
        };

        fetchSupportUrl();
        
        return () => {
            isMounted = false;
        };
    }, []); // Pusty array - wykonaj tylko raz przy montowaniu

    const handleSupportClick = () => {
        if (supportUrl) {
            console.log('[Support] Otwieranie nowej karty z URL:', supportUrl);
            window.open(supportUrl, '_blank', 'noopener,noreferrer');
        } else {
            console.warn('[Support] Brak URL - nie można otworzyć');
            showErrorMessage(t('support.error.noUrl', 'Adres wsparcia nie jest dostępny.'));
        }
    };

    return (
        <>
            <div 
                className={`support-button ${isLoading ? 'loading' : ''}`}
                id="support-button"
                onClick={handleSupportClick}
            >
                <div className="support-icon-wrapper">
                    {isLoading ? (
                        <i className="pi pi-spin pi-spinner" style={{ fontSize: '22px' }}></i>
                    ) : (
                        <SupportIcon className="support-icon" />
                    )}
                </div>
            </div>
            <Tooltip target="#support-button" content={t('topBar.support', 'Support')} />
        </>
    );
};

export default Support;
